var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"store-info-bar"},[_c('div',{staticClass:"store-info"},[_c('LocationIcon'),_c('span',[_vm._v(_vm._s(_vm.$i18n.choice(_vm.store.address)))]),_c('TelIcon'),_c('span',[_vm._v(_vm._s(_vm.store.tel))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }